import React, { useEffect } from 'react'

import Bugsnag, { NotifiableError } from '@bugsnag/js'
import { Modal, ModalBody } from 'flowbite-react'

import { PageInternalError } from './500'

export function ErrorBoundaryContent({ error, back }: { error: unknown; back?: boolean }) {
  let errorComponent: React.ReactElement

  useEffect(() => {
    if (error) {
      Bugsnag.notify(error as NotifiableError)
    }
  }, [error])

  if (error) {
    errorComponent = <PageInternalError error={error} back={back} />
  } else {
    errorComponent = <PageInternalError back={back} />
  }

  return <>{errorComponent}</>
}

export function ErrorBoundaryModal({ error }: { error: unknown }) {
  return (
    <Modal show position="center" size="4xl">
      <ModalBody>
        <ErrorBoundaryContent error={error} back />
      </ModalBody>
    </Modal>
  )
}
